const Adsense = {
  props: {
    format: {
      default: 'auto',
    },
    unit: {
      required: true,
    },
    client: {
      default: 'ca-pub-1409721828621515',
    },
  },
  created() {
    setTimeout(() => {
      (adsbygoogle = window.adsbygoogle || []).push({});
    }, 0);
  },
  methods: {},
  template: `
    <div :class="{publi: true,  ['format-'+format]: true}">
      <ins class="adsbygoogle"
           style="display:block"
           :data-ad-slot="unit"
           :data-ad-client="client"
           data-ad-format="auto"
           data-full-width-responsive="true"
      ></ins>
    </div>
	`,
};
